import { useEffect, useState } from "react";
import Popup from "../../Popup/Popup";
import Item from "../../Delivery/NewAddresses/Item/Item";
import styles from "./styles.module.css";
import AddEditAddress from "../../../pages/Address/newAddress/AddEditAddress/AddEditAddress";
import useAddress from "../../../pages/Address/newAddress/useAddress";

import { ReactComponent as PlusIcon } from "../../../../assets/svg/plus.svg";
import { useTranslation } from "react-i18next";
import { Button, Drawer } from "antd";
// import { AddressItemTransformer } from '../../../../services/objectTransformer/address';

const PaymentBillingAddress = ({
  checkoutId,
  openBillingAddress,
  billingAddress,
  onSubmit: onSelectAddress,
  onClose,
  selectedAddress,
  setSelectedAddress,
}) => {
  const { addresses, onSelectLocation, onCreateModal, onSubmit } = useAddress();
  const { t } = useTranslation();

  useEffect(() => {
    if (openBillingAddress) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [openBillingAddress]);

  return (
    <>
      <Drawer
        open={openBillingAddress}
        onClose={onClose}
        title={t("cart.address_add")}
        placement="bottom"
        height={460}
        classNames={{
          header: styles.drawerHeader,
        }}
        style={{
          borderTopLeftRadius: "25px",
          borderTopRightRadius: "25px",
        }}
        styles={{
          body: {
            display: "flex",
            flexDirection: "column",
            padding: "16px",
          },
        }}
      >
        <div className={styles.container}>
          <div className={styles.addresses}>
            {addresses.map((addressItem, addressIndex) => {
              return (
                <Item
                  {...addressItem}
                  onClick={() => setSelectedAddress(addressItem)}
                  active={addressItem.id === selectedAddress?.id}
                  last={addressIndex === addresses.length - 1}
                  key={addressItem.id}
                />
              );
            })}
          </div>
          <div className={styles.AddAddressButton} onClick={onCreateModal}>
            <div className={styles.AddAddressButtonIconContainer}>
              <PlusIcon />
            </div>
            <span>{t("cart.address_add")}</span>
          </div>
        </div>
        <Button
          type="primary"
          size="large"
          style={{
            width: "100%",
            marginTop: "auto",
          }}
          onClick={() =>
            onSelectAddress({
              id: checkoutId,
              billingAddress: {
                companyName: selectedAddress?.company_name,
                streetAddress1: selectedAddress?.address,
                streetAddress2: selectedAddress?.details,
                country: selectedAddress?.country,
                countryArea: selectedAddress?.region,
                postalCode: selectedAddress?.postal_code,
                city: selectedAddress?.city,
                metadata:
                  selectedAddress?.location?.lng &&
                  selectedAddress?.location?.lat
                    ? [
                        {
                          key: "location",
                          value: `${selectedAddress?.location?.lng}, ${selectedAddress?.location?.lat}`,
                        },
                      ]
                    : [],
                firstName: selectedAddress?.firstName,
                lastName: selectedAddress?.lastName,
                phone: selectedAddress?.phone,
              },
              validationRules: { checkRequiredFields: false },
            })
          }
        >
          {t("common.select")}
        </Button>
      </Drawer>
      <AddEditAddress onSelectLocation={onSelectLocation} onSubmit={onSubmit} />
    </>
  );
};

export default PaymentBillingAddress;
